import { Controller } from "@hotwired/stimulus"

// Disables the Update submit until the quantity differs from its initial value.
export default class extends Controller {
  static targets = ["input", "submit"]
  connect() { this._initial = this.inputTarget.value; this.check() }
  check() {
    const changed = this.inputTarget.value !== this._initial
    this.submitTarget.disabled = !changed
  }
}
